<template>
<div class="chapter">
<div class="inner_page">
<div class="group">
<p class="C593"><span class="size_145"><span class="color_0B0E11"><strong><span id="page_14">Proportion</span></strong></span></span></p>
<p class="C580">Proportion is the relationship created between different contrasting elements. Contrast, in value and scale, is created by varying the proportion of opposing elements—dark and light or big and small. Correct proportion is the point of harmony between these contrasting elements. Consistently sized elements are not very interesting; it is only when there is a variation that scale suddenly becomes an important tool. This variety in size is a valuable design element and allows you to assign importance, to create relationships between elements, and to move your eye around the design. A harmonious design is when the proportions are right; alternatively, you can deliberately create disharmony between elements with out-of-proportion elements.</p>
</div>
<p class="C580">The asymmetrical block of triangles in <em>Peacock Blue</em> is balanced with appliqué designs on one side and space on the other.</p>
<div class="group">
<p class="C572"><img alt="" src="img/15_1.jpg"/></p>
<p class="C694"><span class="size_85"><em>Peacock Blue</em></span>(<span href="#/xhtml/31_Peacock#page_98" title="Link target outside of Sample">page 98</span>)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10___Propor.vue?11164d32